import React from 'react'

const OwnerContext = React.createContext(null)

const OwnerProvider = ({ children }) => {
  const [owner, setOwner] = React.useState(null)
  const [tasks, setTasks] = React.useState([])

  const restricted = React.useMemo(
    () => Boolean(owner?.restricted ?? true),
    [owner]
  )

  const internal = React.useMemo(() => Boolean(owner?.type?.external), [owner])

  const deleted = React.useMemo(() => Boolean(owner?.deleted_at), [owner])

  return (
    <OwnerContext.Provider
      value={{
        owner,
        setOwner,
        restricted,
        internal,
        deleted,
        tasks,
        setTasks
      }}
    >
      {children}
    </OwnerContext.Provider>
  )
}

export default OwnerProvider

export const useOwner = () => React.useContext(OwnerContext)
